export default "__VITE_ASSET__Boydupa0__"